/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Double_Trial_TitleInputs */

const en_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't Go Yet! Get Double the Trial Days`)
};

const ar_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا تغادر بعد! احصل على ضعف أيام التجربة المجانية`)
};

const de_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warte kurz! Hol dir doppelt so viele Testtage`)
};

const es_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Espera! Obtén el doble de días de prueba`)
};

const fr_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attendez ! Profitez du double de jours d'essai`)
};

const it_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspetta! Ottieni il doppio dei giorni di prova`)
};

const ja_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ちょっと待って！無料体験日数が2倍に！`)
};

const ko_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠깐만요! 무료 체험 기간 2배 드려요!`)
};

const pt_br_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não vá ainda! Ganhe o dobro de dias de teste`)
};

const ru_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не уходите! Получите вдвое больше дней пробного периода`)
};

const th_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อย่าเพิ่งไปนะ! รับสิทธิ์ทดลองใช้เพิ่มเป็น 2 เท่า`)
};

const tr_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemen gitmeyin! Deneme sürenizi iki katına çıkarın`)
};

const zh_cn_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先别走，送你双倍试用天数！`)
};

const zh_tw_double_trial_title = /** @type {(inputs: Double_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先別走，送你雙倍試用天數！`)
};

/**
* | output |
* | --- |
* | "Don't Go Yet! Get Double the Trial Days" |
*
* @param {Double_Trial_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const double_trial_title = /** @type {((inputs?: Double_Trial_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Double_Trial_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_double_trial_title(inputs)
	if (locale === "ar") return ar_double_trial_title(inputs)
	if (locale === "de") return de_double_trial_title(inputs)
	if (locale === "es") return es_double_trial_title(inputs)
	if (locale === "fr") return fr_double_trial_title(inputs)
	if (locale === "it") return it_double_trial_title(inputs)
	if (locale === "ja") return ja_double_trial_title(inputs)
	if (locale === "ko") return ko_double_trial_title(inputs)
	if (locale === "pt_br") return pt_br_double_trial_title(inputs)
	if (locale === "ru") return ru_double_trial_title(inputs)
	if (locale === "th") return th_double_trial_title(inputs)
	if (locale === "tr") return tr_double_trial_title(inputs)
	if (locale === "zh_cn") return zh_cn_double_trial_title(inputs)
	return zh_tw_double_trial_title(inputs)
});